// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2PK5U","form":"styles_form__2i-sf"};